import { Routes, Route } from "react-router-dom";
// import HeaderRentalPlan from "../Components/RentalPlan/headerRentalPlan";
import ListRentalPlans from "../Components/Resale Plan/rentalPlanList";
// import AddRentalPlan from "../Components/RentalPlan/addRentalPlan";
// import EditRentalPlan from "../Components/RentalPlan/editRentalPlan";
// import ViewRentalPlan from "../Components/RentalPlan/viewRentalPlan";

const RentalPlanRoutes = () => {
  return (
    <Routes>
      <Route path="/resale_plan" element={<ListRentalPlans />} />
      {/* <Route path="/rental_plan/list" element={<ListRentalPlans />} /> */}
      {/* <Route path="/rental_plan/add" element={<AddRentalPlan />} /> */}
      {/* <Route path="/rental_plan/edit/:id" element={<EditRentalPlan />} /> */}
      {/* <Route path="/rental_plan/view/:id" element={<ViewRentalPlan />} /> */}
    </Routes>
  );
};

export default RentalPlanRoutes;